<div class="not-authorized">
    <h1>Access denied</h1>
    <p>You do not have permission to open this page.</p>
    <p><a routerLink="/">Return to the application home</a></p>
</div>
